import { render, staticRenderFns } from "./AnexosGrid.vue?vue&type=template&id=20247510&"
import script from "./AnexosGrid.vue?vue&type=script&lang=ts&"
export * from "./AnexosGrid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports